<button
  type="button"
  class="btn--header-action"
  [matTooltip]="'Buttons.Export' | translate"
  [matTooltipPosition]="'above'"
  [attr.aria-label]="'Buttons.Export' | translate"
  (click)="print()"
>
  <app-icon name="bold-download-minimalistic" size="xs"></app-icon>
</button>
